define(['angular'], function(angular) {


    /**
     * @class emailService
     */
    function EmailService($http, emailProvider, userService, orderService, goodwillGesturesService) {
        var self = this;

        /**
         * Prepare options to send an email
         * @param  {Object} options
         * {
         * }
         * @return {}
         */
        self.send = function send(options) {
            return emailProvider.send(options).then(function(res) {
                return res.data;
            });
        };

        /**
         * Create email content to notify an order was signed with discount(s) above allowed rate
         * @param  {Object} order
         * @return {String} Content of the message
         */
        self.discountNotification = function discountNotification(order) {
            var rds = userService.findPerson(order.RDSRef);
            var options = orderService.checkDiscounts(order.options);
            var nbOptions = options.length;
            var plural = nbOptions > 1 ? 's' : '';
            var message = [
                'La commande #' + order.id + " vient d'être signée:",
                'Identifiant magasin: ' + (order.client.storeId || 'Non renseigné'),
                'Client: ' + order.client.firstName + ' ' + order.client.lastName,
                'RDS: ' + (rds ? rds.user.firstname + ' ' + rds.user.lastname : order.RDSRef),
                'Option' +
                    plural +
                    ' avec une remise supérieure à ' +
                    goodwillGesturesService.ALLOWED_DISCOUNT_RATE +
                    '% :'
            ];
            var optionLines = options.map(function(option) {
                return '- ' + option.label + ' : ' + option.discount + '% de remise.';
            });
            message.push.apply(message, optionLines);
            return {
                subject: 'Signature BDC: Remise avec autorisation',
                content: message.join('<br>')
            };
        };

        return self;
    }

    EmailService.$inject = ['$http', 'email', 'userService', 'orderService', 'goodwillGesturesService'];

    angular.module('app.bdc.common.emailService', []).factory('emailService', EmailService);
});
